(() => {
  const toWhole = (value, fallback) => {
    const number = Number(value);
    return Number.isInteger(number) && number >= 0 ? number : fallback;
  };

  // Splits the needed placemats across colors, raising every color to the minimum.
  const suggestSplit = (needed, colors, minimum) => {
    const base = Math.floor(needed / colors);
    const remainder = needed % colors;
    return Array.from({ length: colors }, (_, index) => Math.max(minimum, base + (index < remainder ? 1 : 0)));
  };

  const plan = ({ seats, extras, quantities, minimum, unitPrice }) => {
    const needed = seats + extras;
    const total = quantities.reduce((sum, quantity) => sum + quantity, 0);
    const shortColors = quantities.map((quantity, index) => (quantity < minimum ? index + 1 : 0)).filter(Boolean);
    return {
      needed,
      total,
      subtotal: total * unitPrice,
      shortColors,
      valid: shortColors.length === 0,
      surplus: Math.max(0, total - needed),
      shortfall: Math.max(0, needed - total),
    };
  };

  const money = (cents) => `$${(cents / 100).toFixed(2)}`;

  const init = (root) => {
    const minimum = toWhole(root.dataset.minimum, 6);
    const unitPrice = toWhole(root.dataset.unitPrice, 500);
    const seatsInput = root.querySelector('[data-planner-seats]');
    const extrasInput = root.querySelector('[data-planner-extras]');
    const colorsSelect = root.querySelector('[data-planner-colors]');
    const rows = root.querySelector('[data-planner-rows]');
    const result = root.querySelector('[data-planner-result]');

    const quantities = () => Array.from(rows.querySelectorAll('input'), (input) => toWhole(input.value, 0));

    const render = () => {
      const outcome = plan({
        seats: toWhole(seatsInput.value, 0),
        extras: toWhole(extrasInput.value, 0),
        quantities: quantities(),
        minimum,
        unitPrice,
      });
      const lines = [`<p class="rumiloo-planner__total"><strong>${outcome.total} placemats · ${money(outcome.subtotal)}</strong> merchandise subtotal</p>`];
      if (!outcome.valid) {
        lines.push(`<p class="rumiloo-planner__warning">Color ${outcome.shortColors.join(', ')} needs at least ${minimum} placemats. Raise the quantity or choose fewer colors.</p>`);
      }
      if (outcome.shortfall) {
        lines.push(`<p>That covers ${outcome.total} of the ${outcome.needed} placemats you need. Add ${outcome.shortfall} more.</p>`);
      } else if (outcome.surplus) {
        lines.push(`<p>You need ${outcome.needed}; this plan includes ${outcome.surplus} extra because each color starts at ${minimum}.</p>`);
      } else {
        lines.push(`<p>This matches the ${outcome.needed} placemats you need.</p>`);
      }
      result.innerHTML = lines.join('');
    };

    const rebuildRows = () => {
      const colors = toWhole(colorsSelect.value, 1) || 1;
      const needed = toWhole(seatsInput.value, 0) + toWhole(extrasInput.value, 0);
      rows.innerHTML = suggestSplit(needed, colors, minimum).map((quantity, index) => `
        <label class="rumiloo-planner__field">
          <span>Color ${index + 1}</span>
          <input type="number" min="${minimum}" step="1" value="${quantity}" inputmode="numeric">
        </label>`).join('');
      render();
    };

    [seatsInput, extrasInput, colorsSelect].forEach((control) => control.addEventListener('input', rebuildRows));
    rows.addEventListener('input', render);
    rebuildRows();
  };

  window.RumilooQuantityPlanner = { plan, suggestSplit };
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-rumiloo-planner]').forEach(init);
  });
})();
